module.exports = __webpack_public_path__ + "static/media/Mario_O@3x.26b6e44e.jpg";